import { ServerFetch } from '../main-model'

export default class PaymentReceiveModel extends ServerFetch {
    getPaymentReceiveBy = (data) => this.authFetch({
        url: 'payment-receive/getPaymentReceiveBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}